/* CREU · Tonos con foto en scroll lateral (Alba, 20-10 15:24).
 * Añade flechas ‹ › a los carruseles .creu-relvar.is-carousel de la ficha
 * (Collar Dans le Coeur, Ma Chérie…), como en el configurador Alquimia.
 * Cada flecha mueve el ancho visible; se ocultan al llegar a los extremos. */
(function () {
  if (window.__creuRelvarScroll) return;
  window.__creuRelvarScroll = true;
  function montar(box) {
    if (box.__arw) return;
    var list = box.querySelector('.creu-relvar__list, .creu-product__completa-grid');
    if (!list) return;
    box.__arw = true;
    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'creu-relvar__arw creu-relvar__arw--prev';
    next.className = 'creu-relvar__arw creu-relvar__arw--next';
    prev.setAttribute('aria-label', 'Anteriores');
    next.setAttribute('aria-label', 'Siguientes');
    prev.textContent = '‹';
    next.textContent = '›';
    box.appendChild(prev);
    box.appendChild(next);
    function estado() {
      var max = list.scrollWidth - list.clientWidth - 2;
      prev.hidden = list.scrollLeft <= 2;
      next.hidden = list.scrollLeft >= max;
      var ph = box.querySelector('.creu-relvar__ph, .creu-product__completa-img');
      if (ph) {
        var top = ph.offsetTop + ph.offsetHeight / 2;
        prev.style.top = next.style.top = top + 'px';
      }
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.9, behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.9, behavior: 'smooth' }); });
    list.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
    setTimeout(estado, 400);
    if (list.scrollWidth <= list.clientWidth + 2) { prev.hidden = next.hidden = true; }
  }
  function todos() { document.querySelectorAll('.creu-relvar.is-carousel, .creu-product__completa--stones').forEach(montar); }
  document.addEventListener('DOMContentLoaded', todos);
  new MutationObserver(todos).observe(document.documentElement, { childList: true, subtree: true });
})();

/* CREU · Collar Dans le Coeur (y cualquier pieza con letras de número fijo,
 * Alba 20-10 15:40): si la opción «número de letras» tiene un solo valor
 * («DOS letras»), se elige sola y se oculta la fila, y queda solo el campo
 * para escribir las letras. */
(function () {
  if (window.__creuLetrasFijas) return;
  window.__creuLetrasFijas = true;
  function fijar() {
    document.querySelectorAll('.creu-sizes--count').forEach(function (box) {
      if (box.__fija) return;
      var radios = box.querySelectorAll('input[type=radio]');
      if (radios.length !== 1) return;
      box.__fija = true;
      box.style.display = 'none';
      if (!radios[0].checked) {
        radios[0].checked = true;
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(fijar, 0); });
  window.addEventListener('load', fijar);
})();
